module.exports = function () {
    //a noop function to use
};